import React from 'react'
import { SVGProps } from 'react'

const FolderIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={126}
    height={126}
    viewBox="0 0 126 126"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M125.004 48.666C124.324 47.4378 123.326 46.4149 122.115 45.7041C120.904 44.9933 119.525 44.6206 118.121 44.625H43.5023C40.9865 44.6249 38.5385 45.4409 36.5259 46.9503C34.5132 48.4597 33.0444 50.5813 32.34 52.9964L17.5704 103.635C16.7929 106.301 15.1717 108.642 12.9502 110.308C10.7287 111.975 8.02681 112.875 5.25 112.875H99.088C101.865 112.875 104.568 111.974 106.79 110.308C109.012 108.641 110.633 106.299 111.411 103.633L125.589 55.0224C125.919 53.9772 126.037 52.8766 125.937 51.7852C125.836 50.6938 125.519 49.6334 125.004 48.666Z" />
      <path d="M12.5212 102.165L27.3 51.5287C28.3296 48.0282 30.4625 44.9539 33.381 42.7638C36.2995 40.5738 39.8474 39.3851 43.4963 39.375H110.25V36.75C110.25 33.9652 109.144 31.2945 107.175 29.3254C105.205 27.3562 102.535 26.25 99.75 26.25H59.7337C58.9515 26.25 58.179 26.0756 57.4726 25.7396C56.7662 25.4036 56.1436 24.9144 55.65 24.3075L50.49 17.9626C49.2608 16.4513 47.7102 15.2329 45.951 14.3961C44.1917 13.5593 42.2681 13.125 40.32 13.125H10.5C7.71523 13.125 5.04451 14.2312 3.07538 16.2004C1.10625 18.1695 0 20.8402 0 23.625L0 102.375C0 103.767 0.553123 105.103 1.53769 106.087C2.52226 107.072 3.85761 107.625 5.25 107.625C6.88866 107.621 8.48199 107.086 9.79235 106.103C11.1027 105.119 12.0599 103.737 12.5212 102.165Z" />
    </g>
  </svg>
)
export default FolderIcon
